/*
 * @Author: Zhouqi
 * @Date: 2025-12-19 18:24:05
 * @LastEditors: Zhouqi
 * @LastEditTime: 2025-12-22 14:23:48
 */
interface CheckBoxIconProps {
  checked: boolean;
}

const CheckBoxIcon: React.FC<CheckBoxIconProps> = ({ checked }) => {
  const isSelected = checked;
  return isSelected ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.92085 2.92085C3.03025 2.81146 3.17862 2.75 3.33333 2.75H10.6667C11.0809 2.75 11.4167 2.41421 11.4167 2C11.4167 1.58579 11.0809 1.25 10.6667 1.25H3.33333C2.7808 1.25 2.2509 1.46949 1.86019 1.86019C1.46949 2.2509 1.25 2.7808 1.25 3.33333V12.6667C1.25 13.2192 1.46949 13.7491 1.86019 14.1398C2.25089 14.5305 2.7808 14.75 3.33333 14.75H12.6667C13.2192 14.75 13.7491 14.5305 14.1398 14.1398C14.5305 13.7491 14.75 13.2192 14.75 12.6667V8C14.75 7.58579 14.4142 7.25 14 7.25C13.5858 7.25 13.25 7.58579 13.25 8V12.6667C13.25 12.8214 13.1885 12.9697 13.0791 13.0791C12.9697 13.1885 12.8214 13.25 12.6667 13.25H3.33333C3.17862 13.25 3.03025 13.1885 2.92085 13.0791C2.81146 12.9697 2.75 12.8214 2.75 12.6667V3.33333C2.75 3.17862 2.81146 3.03025 2.92085 2.92085ZM15.197 3.19699C15.4899 2.9041 15.4899 2.42923 15.197 2.13633C14.9041 1.84344 14.4292 1.84344 14.1363 2.13633L8 8.27267L6.53033 6.803C6.23744 6.51011 5.76256 6.51011 5.46967 6.803C5.17678 7.09589 5.17678 7.57077 5.46967 7.86366L7.46967 9.86366C7.76256 10.1566 8.23744 10.1566 8.53033 9.86366L15.197 3.19699Z"
        fill="#333"
        fillOpacity="0.8"
      />
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.33333 2.75C3.01117 2.75 2.75 3.01117 2.75 3.33333V12.6667C2.75 12.9888 3.01117 13.25 3.33333 13.25H12.6667C12.9888 13.25 13.25 12.9888 13.25 12.6667V3.33333C13.25 3.01117 12.9888 2.75 12.6667 2.75H3.33333ZM1.25 3.33333C1.25 2.18274 2.18274 1.25 3.33333 1.25H12.6667C13.8173 1.25 14.75 2.18274 14.75 3.33333V12.6667C14.75 13.8173 13.8173 14.75 12.6667 14.75H3.33333C2.18274 14.75 1.25 13.8173 1.25 12.6667V3.33333Z"
        fill="#333"
        fillOpacity="0.8"
      />
    </svg>
  );
};
export default CheckBoxIcon;
